import api from "../../utils/apiUserCliente";

const BASE_URL = "/api/cliente/direcciones";

export const getDireccionesCliente = async () => {
  const res = await api.get(`${BASE_URL}/obtener`);
  return res.data;
};

export const createDireccionCliente = async (payload) => {
  const res = await api.post(`${BASE_URL}/crear`, payload);
  return res.data;
};

export const updateDireccionCliente = async (id, payload) => {
  const res = await api.put(`${BASE_URL}/actualizar/${id}`, payload);
  return res.data;
};

export const deleteDireccionCliente = async (id) => {
  const res = await api.delete(`${BASE_URL}/eliminar/${id}`);
  return res.data;
};